var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _g5, _path11, _g6, _path12, _g7, _path13, _g8, _path14, _g9, _path15, _g10, _path16, _g11, _path17, _g12, _path18, _g13, _path19, _g14, _path20, _g15, _path21, _g16, _path22, _g17, _path23, _g18, _path24, _g19, _path25, _g20, _path26, _g21, _path27, _g22, _path28, _g23, _path29, _g24, _path30, _g25, _path31, _g26, _path32, _g27, _path33, _g28, _path34, _g29, _path35, _g30, _path36, _g31, _path37, _g32, _path38, _g33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCafeteria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.5 431.5H48.5V37.4999C48.5 32.4999 52.6 28.3999 57.6 28.3999H442.4C447.4 28.3999 451.5 32.4999 451.5 37.4999V431.5Z",
    className: "illustration_primary-ultralight"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "#2A9DD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M487.5 471.6H12.5C10 471.6 8 469.6 8 467.1V455.7H492V467.1C492 469.6 490 471.6 487.5 471.6Z",
    fill: "#FFE600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492 455.6L426.6 404.4V300.4H73.4V404.4L8 455.6H492Z",
    fill: "#B08952"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.5 455.9C247.1 448.6 255.2 444.6 262 439.8C283.2 425.7 305.1 412 325 396.2C334.4 388.6 344.1 380.3 350.5 370.1C352.2 367.3 353.7 364.2 353.6 361.1C353.1 354 346.6 349.7 340.7 346.1C333.7 342.1 325.8 339.1 317.8 336.5C285.1 326.6 250.5 322.6 216.5 319.5C182.2 316.5 147.6 315.2 113.1 314.7C164.9 314.2 216.9 314.3 268.5 319.7C294.5 322.8 321.2 325.9 345.4 337.4C370.2 350.1 369.4 367.3 353.3 387.6C347.8 394.8 341.6 401.3 335.3 407.6C314.1 428.5 290.9 446.6 266.7 463.6C261.7 466.9 256.5 469.2 250.4 469.5C243.3 470 238.7 461.8 242.5 455.9Z",
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.8 83.8H327.9V90.4H441.8V83.8Z",
    className: "illustration_primary-lightest"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_359_45697)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21 409.7L-21.5 409.4C-21 408.5 29.6 323 60.4 281.4C88.5 243.4 135.5 179.9 138.5 79.5999C140 28.9999 152.9 1.49995 163.5 -12.8C175 -28.3 186.3 -31.8 186.4 -31.8L186.6 -31.2001C186.5 -31.2001 175.3 -27.7 164 -12.4C153.5 1.79995 140.7 29.1999 139.2 79.5999C136 180 89 243.7 60.9 281.7C30.1 323.3 -20.5 408.8 -21 409.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4001 286.5C54.2001 286.5 46.7001 285.5 39.8001 283.5C19.0001 277.3 3.9001 261.8 -4.9999 237.2C-21.9999 190.2 -2.19991 137.1 48.0001 95.1C61.7001 83.7 76.9001 73.7001 93.1001 65.4001C91.7001 35.0001 94.5001 10.6 94.5001 10.3L95.1001 10.4C95.1001 10.7 92.3001 34.9 93.7001 65.1C117.2 53.2001 142.7 44.9001 168.8 40.9001C218.1 33.3001 265.3 41.5 305.2 64.7C338 83.7 356.9 105.9 361.8 130.9C363.7 130.4 365.6 129.9 367.6 129.5C386.8 125.2 407.4 123.9 428.8 125.7C465.2 128.8 491.6 139.8 491.9 140L492 140.1V140.2C492.1 140.6 502.9 179.2 477.2 211.6C465.4 226.6 447.6 238.1 424.4 245.7C396.3 254.9 359.9 258.6 316.2 256.6C306.7 256.2 297.9 255.4 289.9 254.2C267.4 271 246 281.8 234.3 284.3L234.2 283.7C245.8 281.2 266.8 270.6 289 254.1C251.3 248.7 229.1 236.5 216.1 222.7C202.2 231.8 187.8 240.7 173.4 248.7C128.6 273.8 91.4001 286.5 62.4001 286.5ZM93.2001 66.2C76.6001 74.7 61.5001 84.7 48.4001 95.6C-1.5999 137.4 -21.2999 190.3 -4.3999 237C4.4001 261.4 19.4001 276.8 40.0001 282.8C71.0001 291.9 115.8 280.2 173.2 248.2C187.5 240.2 201.9 231.3 215.8 222.2C208.3 214.1 204 205.6 201.5 197.6C200.3 193.8 199.6 189.9 199.1 186C191 187.1 182.2 187.7 172.8 187.8C172.7 187.8 172.5 187.8 172.4 187.8C152.8 187.8 136.5 180.7 123.9 166.6C102.1 142.3 95.3001 101.1 93.4001 70.8001C93.3001 69.3001 93.3001 67.7 93.2001 66.2ZM290.7 253.7C298.6 254.8 307.1 255.5 316.4 256C360 258 396.3 254.4 424.3 245.2C447.4 237.6 465.1 226.2 476.8 211.3C501.4 180.1 492.2 143.2 491.5 140.6C489.4 139.7 463.7 129.4 428.7 126.5C410.1 124.9 386.6 125.4 362 131.8C363.5 139.7 363.5 147.8 362.2 156.2C357.8 183.6 337.7 214 305.6 241.8C300.7 245.9 295.7 249.9 290.7 253.7ZM216.7 222.3C229.7 236 252 248.2 289.8 253.5C294.9 249.7 300 245.5 305.1 241.1C337.1 213.4 357.1 183.1 361.5 155.8C362.8 147.5 362.8 139.4 361.3 131.6C341.9 136.7 321.8 145.6 302.7 160.2C283.2 175.3 251.6 199.4 216.7 222.3ZM199.7 185.9C200.2 189.8 200.9 193.7 202.1 197.4C204.5 205.3 208.8 213.8 216.3 221.8C251.2 198.9 282.8 174.7 302.4 159.7C319.9 146.3 339.7 136.6 361.2 130.9C356.4 106.1 337.5 84 304.9 65.1C235 24.7 154.6 35.0001 93.8001 65.9001C93.9001 67.5 94.0001 69.1001 94.1001 70.8001C96.0001 101 102.8 142 124.4 166.2C136.9 180.2 153.2 187.3 172.8 187.2C181.9 187.2 190.6 186.5 199 185.4C195.3 150.5 217.4 111.5 243.2 92.3C258.3 81.2001 272.6 78.6001 282.6 85.3C297.3 95.2001 302.8 109.1 298.2 124.6C293.4 140.3 278.5 156 257.2 167.7C244.6 174.5 225.4 182.4 199.7 185.9ZM270.1 82.2C262.2 82.2 253.1 85.8 243.6 92.8C217.9 111.8 195.9 150.6 199.6 185.3C252.1 178 289.6 150.7 297.5 124.4C302.1 109.2 296.6 95.5 282.2 85.8C278.7 83.4 274.6 82.2 270.1 82.2Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.8 135H327.9V141.6H441.8V135Z",
    className: "illustration_primary-lightest"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.5 90.3999H337.6V96.9999H451.5V90.3999Z",
    className: "illustration_primary_default"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.5 141.6H337.6V148.2H451.5V141.6Z",
    className: "illustration_primary_default"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.5 194.5C281 197.2 255.2 211.9 247 211.8C246.4 211.8 247.2 190.8 249.4 192.4C251.6 194 267.2 188.6 274.5 187.7C289.5 185.9 259 137.3 272.6 138.5C277 138.9 277.4 139.3 280 142.1C289.2 152.4 298.4 191.7 289.5 194.5Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.2 225.8H248.6C238.9 225.8 234.1 231 234.1 216.1L231 164.2C231 142.7 236.3 140.3 238.9 139.6C243.7 138.3 247.9 138.5 259 138.5C268 138.5 272.5 137.5 276.4 139.6C282.2 142.7 281.8 147.8 281.8 162.6L281.2 216.1C281.2 231 277.9 225.8 268.2 225.8Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.801 198.5C280.301 198.5 279.901 198.1 279.901 197.6L279.101 160.3C279.101 159.8 279.501 159.3 280.001 159.3C280.501 159.3 281.001 159.7 281.001 160.2L281.801 197.5C281.701 198 281.301 198.5 280.801 198.5Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9 195.4C258.4 195.4 258 195 258 194.5L255.9 154.9C255.9 154.4 256.3 153.9 256.8 153.9C257.3 153.9 257.8 154.3 257.8 154.8L259.9 194.4C259.9 194.9 259.5 195.4 258.9 195.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.4 139.8C250.4 139.8 244.4 139.7 243.7 141.3C243 142.9 254.8 154 254.8 154C255.7 155.2 257.8 155.2 258.7 154C258.7 154 271.1 140.1 267.4 139.8C263.8 139.5 250.4 139.8 250.4 139.8Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2 206H233.9V217.5H281.2V206Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.601 202.3C250.601 202.3 260.301 203.7 268.201 204.2C268.801 204.2 269.401 204.3 270.101 204.4C273.001 204.7 276.101 204.1 277.801 203.4C279.901 202.5 273.701 201.6 273.701 201.6C273.701 201.6 279.701 202.6 279.901 200.7C280.001 199.6 278.701 198.6 276.501 198.4C278.901 198.6 279.901 198.6 280.701 197.3C281.601 195.8 276.901 195.4 276.201 195.4C276.801 195.4 280.501 196.4 280.801 194.5C281.201 192.5 271.501 192.2 271.501 192.2C271.501 192.2 275.101 192.6 274.901 190.8C274.801 188.9 262.901 192 260.601 192.8C258.301 193.5 250.801 191.6 250.801 191.6L250.601 202.3Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.6 122.1C263.8 126.9 265.3 138.6 265.8 141.1C266.3 143.6 256.5 153 246.6 143.3L248.6 115.5C248.7 115.5 263.3 110.3 263.6 122.1Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.8 102.7C274.7 110.2 273.9 118.3 272.5 129C271.6 135.7 263.9 140.9 255.6 135.1C246.9 129.1 244.3 121.4 245.7 113.3C246.1 111 245.3 106.1 247 103.8C250.1 99.3001 273.5 100.2 273.8 102.7Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.199 102.7C278.199 106.1 274.699 105.7 274.699 105.7C274.699 105.7 275.699 107.2 274.199 108.1C270.899 109.9 267.599 105.5 267.599 105.5C267.599 105.5 267.899 107.2 263.399 107.1C262.099 107.1 260.799 105.5 260.799 105.5C260.799 105.5 259.899 106.7 257.499 106.7C255.099 106.7 253.499 108.9 253.499 108.9C253.699 109.3 252.399 115.6 250.899 116.8C250.499 117.1 249.299 115.8 249.299 115.8C249.299 115.8 249.299 122.1 246.399 122C242.799 121.8 243.999 105.2 247.799 101.5C251.199 97.9 266.599 93 275.199 102.7Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.6 123.5C247.6 123.5 244.9 123.5 243.8 122.3C242.1 120.5 242.6 116.6 244 114.8C245.4 113 248.7 114.7 249.5 116.3",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265 130.6C264 130.6 262.7 130.5 261.1 130C260.8 129.9 260.5 129.6 260.6 129.2C260.7 128.8 261 128.6 261.4 128.7C265.7 129.8 267.1 128.8 267.1 128.8C267.4 128.6 267.8 128.6 268 128.9C268.2 129.2 268.2 129.6 267.9 129.8C267.9 130 267 130.6 265 130.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.999 126.3C263.999 126.3 263.099 126.1 262.699 126C262.399 125.9 262.099 125.6 262.199 125.2C262.299 124.9 262.599 124.6 262.999 124.7C264.299 125 266.299 125.1 266.699 124.4C267.099 123.7 266.299 120.7 265.299 118.4C265.199 118.1 265.299 117.7 265.599 117.6C265.899 117.5 266.299 117.6 266.399 117.9C266.899 119.2 268.599 123.5 267.699 125.1C267.299 126 266.099 126.3 264.999 126.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260 117.9C260.718 117.9 261.3 117.363 261.3 116.7C261.3 116.037 260.718 115.5 260 115.5C259.282 115.5 258.7 116.037 258.7 116.7C258.7 117.363 259.282 117.9 260 117.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3 117.9C270.018 117.9 270.6 117.363 270.6 116.7C270.6 116.037 270.018 115.5 269.3 115.5C268.582 115.5 268 116.037 268 116.7C268 117.363 268.582 117.9 269.3 117.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.1 120.6C247 120.6 246.9 120.6 246.8 120.5C246.5 120.3 246.3 120 246.5 119.6C246.8 119 247 118.1 246.8 118C246.8 118 246.6 117.9 246.3 118C245.9 118.1 245.6 117.8 245.5 117.5C245.4 117.1 245.7 116.8 246 116.7C247 116.5 247.6 116.9 247.8 117.2C248.5 118.1 247.8 119.9 247.6 120.2C247.6 120.5 247.3 120.6 247.1 120.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.3 136.7C255.4 135.8 250.4 131.2 250.4 131.2C250.3 131.1 250.3 131 250.4 130.9C250.5 130.8 250.6 130.8 250.7 130.9C250.7 130.9 255.6 135.4 261.4 136.3C261.5 136.3 261.6 136.4 261.6 136.6C261.5 136.6 261.4 136.7 261.3 136.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 113.8C257.5 113.8 257.3 113.6 257.2 113.4C257.2 113.1 257.4 112.9 257.6 112.9L262.2 112.4C262.4 112.4 262.7 112.6 262.7 112.8C262.7 113.1 262.5 113.3 262.3 113.3L257.7 113.8Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 113.2L268 112.7C267.7 112.7 267.6 112.4 267.6 112.2C267.6 111.9 267.9 111.8 268.1 111.8L272 112.3C272.3 112.3 272.4 112.6 272.4 112.8C272.4 113.1 272.2 113.2 272 113.2Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9 139.6C233.7 140.6 228.1 146.6 225.8 156.8C225 160.2 223.1 183.9 223.9 191.1C224.6 198.4 225.9 198 231.8 199.9C235.4 201 250 206 262 206.7C265.2 206.9 265.7 207.7 265.7 206C265.7 206 265.9 191.7 263.4 191.4L245.3 189.8C242.7 189.4 240.7 187.1 240.8 184.4L241.4 159C241.3 158.2 246.4 138.3 238.9 139.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3 193.2C261.2 193.2 261.1 193.2 261.1 193.2L228.7 185.1C228.2 185 227.9 184.5 228 184C228.1 183.5 228.6 183.2 229.1 183.3L261.5 191.4C262 191.5 262.3 192 262.2 192.5C262.1 192.9 261.7 193.2 261.3 193.2Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4 185.6C231.8 185.6 231.4 185.1 231.5 184.6L232.7 161.5C232.7 161 233.2 160.6 233.7 160.6C234.2 160.6 234.6 161.1 234.6 161.6L233.4 184.7C233.3 185.2 232.9 185.6 232.4 185.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.7 185.3C281.3 185.3 281 185.1 280.8 184.7C280.6 184.2 280.8 183.7 281.3 183.5L286.5 181.4C287 181.2 287.5 181.4 287.7 181.9C287.9 182.4 287.7 182.9 287.2 183.1L282 185.2C281.9 185.3 281.8 185.3 281.7 185.3Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 162C261.884 162 262.6 161.284 262.6 160.4C262.6 159.516 261.884 158.8 261 158.8C260.117 158.8 259.4 159.516 259.4 160.4C259.4 161.284 260.117 162 261 162Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.701 169.9C262.584 169.9 263.301 169.184 263.301 168.3C263.301 167.416 262.584 166.7 261.701 166.7C260.817 166.7 260.101 167.416 260.101 168.3C260.101 169.184 260.817 169.9 261.701 169.9Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.201 216.1H234.101V273.6H281.201V216.1Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.6 177.8C263.484 177.8 264.2 177.084 264.2 176.2C264.2 175.316 263.484 174.6 262.6 174.6C261.716 174.6 261 175.316 261 176.2C261 177.084 261.716 177.8 262.6 177.8Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 163.4H242.2V165H250V163.4Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.7 213.1H242V273.6H273.7V213.1Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1 231.5L241.4 232.7V185.9L262.8 190.8L263.1 231.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.2 300H157C156.5 300 156.1 299.6 156.1 299.1V205.6C156.1 205.1 156.5 204.7 157 204.7H448.2C448.7 204.7 449.1 205.1 449.1 205.6V299.1C449.1 299.6 448.7 300 448.2 300Z",
    fill: "#2A9DD6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_359_45697)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.2 300H157C156.5 300 156.1 299.6 156.1 299.1V205.6C156.1 205.1 156.5 204.7 157 204.7H448.2C448.7 204.7 449.1 205.1 449.1 205.6V299.1C449.1 299.6 448.7 300 448.2 300Z",
    className: "illustration_primary"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.8 306H63.6999C61.8999 306 60.3999 304.5 60.3999 302.7V297.3C60.3999 295.5 61.8999 294 63.6999 294H445.8C447.6 294 449.1 295.5 449.1 297.3V302.7C449.1 304.5 447.6 306 445.8 306Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 356.1H229.6C230.6 356.1 231.4 355.3 231.4 341.8V320C231.4 320 230.6 311.9 229.6 311.9H224C223 311.9 222.2 320 222.2 320V341.8C222.2 355.3 223 356.1 224 356.1Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.899 356.1H285.499C286.499 356.1 287.299 355.3 287.299 341.8V301.3C287.299 312.8 286.499 311.9 285.499 311.9H279.899C278.899 311.9 278.099 312.7 278.099 301.3V341.8C277.999 355.3 278.899 356.1 279.899 356.1Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 378.6H295.9C296.9 378.6 297.7 377.8 297.7 376.8V323.8C297.7 322.8 296.9 322 295.9 322H290.3C289.3 322 288.5 322.8 288.5 323.8V376.8C288.4 377.8 289.2 378.6 290.3 378.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 378.6H233.6C234.6 378.6 235.4 377.8 235.4 376.8V323.8C235.4 322.8 234.6 322 233.6 322H228C227 322 226.2 322.8 226.2 323.8V376.8C226.1 377.8 227 378.6 228 378.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3 312.6V320.8C217.3 321.3 217.4 321.7 217.5 322.1C218.1 324.5 220.3 326.3 222.9 326.3H299.8C302.9 326.3 305.4 323.8 305.4 320.7V233.1C305.4 230 302.9 227.5 299.8 227.5H279.1C276 227.5 273.5 230 273.5 233.1V306.9H222.9C219.8 307.1 217.3 309.6 217.3 312.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3 309.5V317.7C217.3 318.2 217.4 318.6 217.5 319H294.4C297.5 319 300 316.5 300 313.4V229.4C300 228.9 299.9 228.5 299.8 228.1H279.1C276 228.1 273.5 230.6 273.5 233.7V304H222.9C219.8 304 217.3 306.5 217.3 309.5Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 356.1H115.5C114.5 356.1 113.7 355.3 113.7 341.8V320C113.7 320 114.5 311.9 115.5 311.9H121.1C122.1 311.9 122.9 320 122.9 320V341.8C122.9 355.3 122.1 356.1 121.1 356.1Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1 378.6H111.5C110.5 378.6 109.7 377.8 109.7 376.8V323.8C109.7 322.8 110.5 322 111.5 322H117.1C118.1 322 118.9 322.8 118.9 323.8V376.8C119 377.8 118.2 378.6 117.1 378.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 312.6V320.8C127.8 321.3 127.7 321.7 127.6 322.1C127 324.5 124.8 326.3 122.2 326.3H45.3998C42.2998 326.3 39.7998 323.8 39.7998 320.7V233.1C39.7998 230 42.2998 227.5 45.3998 227.5H66.0998C69.1998 227.5 71.6998 230 71.6998 233.1V306.9H122.3C125.3 307.1 127.8 309.6 127.8 312.6Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 309.5V317.7C127.8 318.2 127.7 318.6 127.6 319H50.6996C47.5996 319 45.0996 316.5 45.0996 313.4V229.4C45.0996 228.9 45.1996 228.5 45.2996 228.1H65.9996C69.0996 228.1 71.5996 230.6 71.5996 233.7V304H122.2C125.3 304 127.8 306.5 127.8 309.5Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 367.6C186.194 367.6 197.7 364.779 197.7 361.3C197.7 357.821 186.194 355 172 355C157.806 355 146.3 357.821 146.3 361.3C146.3 364.779 157.806 367.6 172 367.6Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.6 363H170.8C168 363 165.7 360.7 165.7 357.9V290.4C165.7 287.6 168 285.3 170.8 285.3H173.6C176.4 285.3 178.7 287.6 178.7 290.4V357.9C178.7 360.7 176.4 363 173.6 363Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 288.4C220.737 288.4 261.3 283.878 261.3 278.3C261.3 272.722 220.737 268.2 170.7 268.2C120.663 268.2 80.0996 272.722 80.0996 278.3C80.0996 283.878 120.663 288.4 170.7 288.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 287.7C220.737 287.7 261.3 283.178 261.3 277.6C261.3 272.022 220.737 267.5 170.7 267.5C120.663 267.5 80.0996 272.022 80.0996 277.6C80.0996 283.178 120.663 287.7 170.7 287.7Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.5 275C109.1 273 119.1 271.7 129.3 271.7C139.5 271.7 149.5 273 152.1 275C155.5 277.6 145.8 280.4 129.3 280.4C112.8 280.4 103.1 277.6 106.5 275Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.5 274.7C109.1 272.7 119.1 271.4 129.3 271.4C139.5 271.4 149.5 272.7 152.1 274.7C155.5 277.3 145.8 280.1 129.3 280.1C112.8 280.1 103.1 277.3 106.5 274.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.899 274.7C116.599 273.4 122.899 272.6 129.399 272.6C135.899 272.6 142.199 273.4 143.899 274.7C146.099 276.4 139.899 278.1 129.399 278.1C118.899 278.1 112.699 276.3 114.899 274.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.6 274.9C188.2 272.9 198.2 271.6 208.4 271.6C218.6 271.6 228.6 272.9 231.2 274.9C234.6 277.5 224.9 280.3 208.4 280.3C191.9 280.3 182.1 277.5 185.6 274.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.6 274.5C188.2 272.5 198.2 271.2 208.4 271.2C218.6 271.2 228.6 272.5 231.2 274.5C234.6 277.1 224.9 279.9 208.4 279.9C191.9 279.9 182.1 277.2 185.6 274.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.9 274.5C195.6 273.2 201.9 272.4 208.4 272.4C214.9 272.4 221.2 273.2 222.9 274.5C225.1 276.2 218.9 277.9 208.4 277.9C197.9 277.9 191.7 276.2 193.9 274.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.6 105.6H122.6H101.6V123.5V148.8H144.8V143.7V127.2V117.8V105.6H132.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4 88.0999H124.8C124.2 88.0999 123.7 87.5999 123.7 86.9999V86.6999C123.7 86.0999 124.2 85.5999 124.8 85.5999H127.4C128 85.5999 128.5 86.0999 128.5 86.6999V86.9999C128.6 87.5999 128 88.0999 127.4 88.0999Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.344 86.5175L116.596 107.24L117.229 107.538L126.978 86.8155L126.344 86.5175Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.909 86.5508L126.276 86.8489L136.027 107.569L136.66 107.271L126.909 86.5508Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1 88.6999H127.4C126.4 88.6999 125.5 87.8999 125.5 86.7999C125.5 85.7999 126.3 84.8999 127.4 84.8999H128.1C129.1 84.8999 130 85.6999 130 86.7999C130 87.7999 129.2 88.6999 128.1 88.6999Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.9 105.6H103.7V148.8H146.9V105.6Z",
    fill: "#DDB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 105.6C133.5 108.9 126.2 109.9 124.1 113.7C118.9 123.3 112.6 123.3 103.7 122.4V105.6H134.5Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.9 130.4V148.8H103.7V141.7C112.3 134.2 124.3 141.7 146.9 130.4Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.3 142.5C133.087 142.5 139.4 141.515 139.4 140.3C139.4 139.085 133.087 138.1 125.3 138.1C117.513 138.1 111.2 139.085 111.2 140.3C111.2 141.515 117.513 142.5 125.3 142.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.9 110.4C119.8 112.1 108.8 118.2 115.3 129.8C117.5 134 121 138.1 125.8 138.9C130.4 139.8 135.3 137.8 139 135C139.6 134.5 140.5 134.6 141 135.2C141.5 135.8 141.3 136.7 140.7 137.2C139.5 138 138.4 138.7 137.2 139.3C133.6 141 129.4 142 125.4 141C120 139.8 116.3 135.2 114.1 130.5C107.9 117.9 119.1 111.4 129.9 110.4Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.801 123.5L134.901 115.7C135.101 115.6 135.501 116 135.601 116.1L139.501 122L139.901 122.6C140.001 122.8 140.001 123.1 139.701 123.2C139.601 123.2 139.601 123.3 139.501 123.3L120.001 131.5C116.501 133 114.601 132.8 113.001 131.6C112.801 131.4 112.601 131.2 112.501 130.9L112.101 129.9C111.301 128 114.501 124.8 117.801 123.5Z",
    fill: "#E2A854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.501 123.1L134.701 115.9C134.901 115.8 135.101 115.7 135.401 115.7L139.301 121.6L139.901 122.6C139.701 122.7 139.501 122.8 139.301 122.9L119.801 131.1C116.301 132.6 114.401 132.4 112.801 131.2C112.601 131 112.401 130.8 112.301 130.5L111.901 129.5C111.001 127.7 114.201 124.5 117.501 123.1Z",
    fill: "#FECE73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.401 123.1L134.601 115.9C134.801 115.8 135.001 115.7 135.301 115.7L139.201 121.6L118.301 130.4C117.001 130.9 114.801 131.6 112.801 131.2C112.601 131 112.401 130.8 112.301 130.5L111.901 129.5C110.901 127.6 111.901 125.5 117.401 123.1Z",
    fill: "#FDDEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8 122.5C137 122.9 135.3 121.7 134.7 120.3C134.1 118.9 133.4 117.3 135.3 115.7L139.8 122.5Z",
    fill: "#FDDEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.801 130.7C114.301 130.8 114.801 130.9 114.801 130.6C114.801 130.4 115.101 130.1 115.001 129.8C114.801 129.3 114.901 129 115.401 129C115.701 129 116.001 129.3 116.001 129.5C116.001 129.8 115.601 129.6 115.501 130C115.401 130.5 116.101 130.8 116.601 130.7C116.901 130.6 117.001 130.6 117.201 130.4C117.401 129.8 116.801 129.7 117.001 129.6C117.201 129.4 117.801 129.6 117.901 129.9C118.101 130.4 117.601 130.2 117.801 130.7C117.901 131 118.301 131.2 118.601 131.1C118.901 131 118.901 130.9 118.901 130.7C118.901 130.4 118.501 130.3 118.601 130.1C118.701 129.8 119.201 129.9 119.501 130.1C119.701 130.2 119.801 130.2 119.801 130.3C119.801 130.6 119.601 130.8 119.601 131C119.601 131.1 119.701 131.2 119.801 131.2C120.101 131.3 120.601 130.8 120.801 130.5C120.801 130.5 120.901 130.4 120.901 130.3C121.101 130.3 121.201 130.3 121.301 130.3C121.801 130.1 122.301 129.8 122.001 129.5C121.901 129.4 121.801 129 121.601 128.9C121.401 128.8 121.201 128.7 121.101 128.6C121.101 128.6 121.101 128.5 121.001 128.5C121.001 128.4 121.001 128.3 121.201 128.1C121.401 127.9 121.901 127.9 122.101 128.1C122.301 128.3 121.901 128.4 122.101 128.7C122.401 129.1 123.201 128.8 123.501 128.4C123.701 128.2 123.801 128.1 123.701 127.8C123.401 127.3 122.901 127.7 122.901 127.4C122.901 127.2 123.501 126.9 123.901 127C124.401 127.2 123.901 127.4 124.401 127.6C124.701 127.7 125.201 127.6 125.401 127.3C125.501 127 125.601 127 125.301 126.8C125.001 126.6 124.701 126.8 124.601 126.7C125.001 126.5 125.201 126.3 125.401 126.1C125.601 126.1 125.601 126 125.701 126.1C125.901 126.3 125.901 126.6 126.101 126.6C126.201 126.6 126.301 126.6 126.501 126.6C126.801 126.4 126.801 125.8 126.701 125.5C126.601 125.2 126.401 124.8 126.101 124.6C126.201 124.3 126.301 124 125.901 123.7C125.701 123.5 125.201 123.2 125.101 123.3C124.601 123.3 124.001 123.4 124.101 123.7C124.201 123.9 124.001 124.3 124.201 124.4C124.201 124.5 124.301 124.5 124.301 124.6C124.101 124.8 123.901 125 123.501 125.2C123.401 125.1 123.401 125.1 123.301 125C123.201 124.7 123.601 124.8 123.601 124.4C123.501 123.9 122.701 123.8 122.301 124.1C122.001 124.3 121.901 124.3 121.901 124.6C121.901 125.2 122.501 125.1 122.401 125.3C122.301 125.5 121.701 125.6 121.401 125.3C121.501 125 121.501 124.7 121.401 124.2C121.401 124.1 121.801 123 120.901 122.8C120.601 122.7 120.001 122.7 120.001 122.7C119.501 122.9 119.001 123.2 119.301 123.5C119.401 123.6 119.501 124 119.701 124.1C120.001 124.2 120.201 124.3 120.301 124.5C120.101 124.6 120.101 124.7 120.101 124.8C120.001 124.9 119.701 125 119.501 124.9C119.501 124.9 119.501 124.8 119.401 124.8C119.301 124.7 119.201 124.7 119.101 124.7C119.101 124.6 119.301 124.4 119.201 124.2C118.901 123.8 118.101 124.1 117.801 124.5C117.601 124.7 117.501 124.8 117.601 125.1C117.901 125.6 118.401 125.2 118.401 125.5C118.401 125.7 117.801 126 117.401 125.9C116.901 125.7 117.401 125.5 116.901 125.3C116.601 125.2 116.101 125.3 115.901 125.6C115.801 125.9 115.701 125.9 116.001 126.1C116.301 126.3 116.601 126.1 116.701 126.2C116.901 126.4 116.401 126.7 116.001 126.8C115.701 126.9 115.601 126.9 115.601 126.9C115.401 126.7 115.401 126.4 115.201 126.4C115.101 126.4 115.001 126.4 114.801 126.4C114.501 126.6 114.501 127.2 114.601 127.5C114.601 127.6 114.601 127.7 114.701 127.8C114.501 128 114.301 128.2 114.101 128.6C114.001 128.7 113.001 129.3 113.401 130C113.501 130.2 113.801 130.7 113.801 130.7Z",
    fill: "#1DB55D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.801 125.1C125.801 125.1 122.301 127.5 121.101 127.7C119.901 127.9 116.301 128.3 116.301 128.3L120.701 127.3L125.801 125.1Z",
    fill: "#5AC486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 122.5C133 124.7 131.7 126.8 129.5 127.3C127.3 127.8 125.2 126.5 124.7 124.3C124.7 124.1 124.6 124 124.6 123.8C124.4 121.8 125.7 119.9 127.7 119.5C129.7 119 131.7 120.1 132.4 122C132.4 122.1 132.4 122.3 132.5 122.5Z",
    fill: "#652A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3 122C132.5 124 131.2 125.9 129.2 126.3C127.2 126.8 125.2 125.7 124.5 123.8C124.3 121.8 125.6 119.9 127.6 119.5C129.6 119 131.6 120.1 132.3 122Z",
    fill: "#852D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 121.1C129 121.4 128.5 121.7 127.9 121.8C127.3 121.9 126.8 121.9 126.6 121.6C126.6 121.3 127.1 121 127.7 120.9C128.3 120.8 128.8 120.9 129 121.1Z",
    fill: "#7A4E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3 122.2C131.3 122.5 130.8 122.8 130.2 122.9C129.6 123 129.1 123 128.9 122.7C128.9 122.4 129.4 122.1 130 122C130.6 121.9 131.1 122 131.3 122.2Z",
    fill: "#7A4E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2 123.9C128.2 124.2 127.7 124.5 127.1 124.6C126.5 124.7 126 124.7 125.8 124.4C125.8 124.1 126.3 123.8 126.9 123.7C127.5 123.6 128.1 123.6 128.2 123.9Z",
    fill: "#7A4E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8 120.9C134.4 121 133.9 121.1 134 121.4C134.1 121.6 134 121.9 134.1 122.1C134.4 122.5 134.5 122.7 134.1 122.9C133.9 123 133.5 122.9 133.4 122.7C133.3 122.4 133.7 122.5 133.6 122.1C133.5 121.7 132.8 121.6 132.5 121.9C132.3 122.1 132.2 122.1 132.2 122.4C132.2 123 132.8 122.8 132.7 123C132.6 123.2 132.1 123.3 131.8 123.1C131.5 122.8 131.9 122.8 131.6 122.4C131.4 122.2 131 122.2 130.8 122.4C130.6 122.6 130.6 122.7 130.7 122.9C130.9 123.2 131.2 123.1 131.2 123.3C131.2 123.5 130.8 123.7 130.5 123.6C130.3 123.6 130.2 123.6 130.2 123.5C130.1 123.2 130.2 123 130.1 122.9C130 122.8 129.9 122.8 129.8 122.8C129.5 122.9 129.3 123.4 129.2 123.8C129.2 123.9 129.2 123.9 129.2 124C129 124 128.9 124.1 128.9 124.1C128.6 124.5 128.3 124.9 128.6 125C128.8 125.1 128.9 125.3 129.2 125.3C129.4 125.3 129.6 125.3 129.7 125.3C129.7 125.3 129.8 125.3 129.8 125.4C129.9 125.5 129.8 125.6 129.8 125.8C129.7 126 129.3 126.2 129.1 126.1C128.8 126 129.2 125.8 128.9 125.6C128.5 125.4 128 125.9 127.8 126.3C127.7 126.6 127.7 126.7 127.9 126.8C128.3 127.1 128.6 126.6 128.7 126.8C128.8 127 128.4 127.5 128 127.5C127.5 127.6 127.9 127.2 127.4 127.2C127.1 127.2 126.7 127.5 126.7 127.8C126.7 128.1 126.7 128.1 126.9 128.2C127.2 128.2 127.4 128 127.5 128.1C127.3 128.4 127.1 128.6 127 128.9C126.9 129 126.8 129.1 126.8 129C126.5 128.9 126.5 128.7 126.3 128.7C126.2 128.7 126.1 128.8 126 128.9C125.8 129.2 126 129.7 126.2 129.9C126.4 130.2 126.7 130.4 127 130.5C127 130.8 127.1 131.1 127.5 131.2C127.8 131.3 128.2 131.3 128.3 131.3C128.7 131.1 129.2 130.8 128.9 130.6C128.8 130.5 128.8 130.1 128.5 130C128.4 130 128.4 129.9 128.3 129.9C128.4 129.7 128.5 129.5 128.7 129.1C128.8 129.1 128.9 129.2 128.9 129.2C129.1 129.4 128.7 129.5 128.9 129.8C129.1 130.2 129.8 129.9 130.1 129.6C130.3 129.4 130.4 129.3 130.3 129.1C130.1 128.6 129.6 128.9 129.6 128.7C129.6 128.5 130.1 128.2 130.4 128.3C130.4 128.6 130.6 128.9 130.8 129.1C130.9 129.2 130.9 130.2 131.7 130C132 129.9 132.5 129.8 132.5 129.7C132.8 129.3 133.1 128.9 132.8 128.8C132.6 128.7 132.5 128.5 132.2 128.5C131.9 128.5 131.7 128.5 131.6 128.4C131.7 128.2 131.7 128.2 131.6 128.1C131.7 127.9 131.9 127.8 132 127.8L132.1 127.9C132.2 127.9 132.3 127.9 132.4 127.9C132.5 128 132.3 128.2 132.5 128.3C132.9 128.5 133.4 128 133.6 127.6C133.7 127.3 133.7 127.2 133.5 127.1C133.1 126.8 132.8 127.3 132.7 127.1C132.6 126.9 133 126.4 133.4 126.4C133.9 126.3 133.5 126.7 134 126.7C134.3 126.7 134.7 126.4 134.7 126.1C134.7 125.8 134.7 125.8 134.5 125.7C134.2 125.7 134 125.9 133.9 125.8C133.7 125.7 134 125.3 134.3 125.1C134.5 124.9 134.6 124.9 134.6 124.9C134.9 125 134.9 125.2 135.1 125.2C135.2 125.2 135.3 125.1 135.4 125C135.6 124.7 135.4 124.2 135.2 124C135.2 123.9 135.1 123.9 135 123.8C135.1 123.6 135.2 123.3 135.2 122.9C135.2 122.8 135.9 121.9 135.3 121.5C135.2 121.1 134.8 120.9 134.8 120.9Z",
    fill: "#1DB55D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9 129.7C126.9 129.7 128.9 126.5 129.8 125.8C130.7 125.2 133.6 123.6 133.6 123.6L130.3 126L126.9 129.7Z",
    fill: "#5AC486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.801 129.8C122.501 131.6 119.901 131.9 118.201 130.6C116.401 129.3 116.101 126.7 117.401 125C117.501 124.9 117.601 124.7 117.701 124.6C119.101 123.2 121.401 123 123.001 124.2C124.601 125.4 125.001 127.7 124.001 129.4C124.001 129.5 123.901 129.7 123.801 129.8Z",
    fill: "#652A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.101 129.4C122.701 130.8 120.401 131 118.801 129.8C117.201 128.6 116.801 126.3 117.801 124.6C119.201 123.2 121.501 123 123.101 124.2C124.701 125.4 125.101 127.7 124.101 129.4Z",
    fill: "#852D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.601 126.2C122.401 126.4 121.901 126.2 121.401 125.8C120.901 125.4 120.601 125 120.701 124.7C120.901 124.5 121.401 124.7 121.901 125.1C122.401 125.5 122.701 126 122.601 126.2Z",
    fill: "#7A4E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2 128.7C123 128.9 122.5 128.7 122 128.3C121.5 127.9 121.2 127.5 121.3 127.2C121.5 127 122 127.2 122.5 127.6C123 128 123.3 128.5 123.2 128.7Z",
    fill: "#7A4E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.001 127.4C119.801 127.6 119.301 127.4 118.801 127C118.301 126.6 118.001 126.2 118.101 125.9C118.301 125.7 118.801 125.9 119.301 126.3C119.801 126.7 120.101 127.1 120.001 127.4Z",
    fill: "#7A4E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1 123.6C138.199 123.6 139.9 121.898 139.9 119.8C139.9 117.701 138.199 116 136.1 116C134.002 116 132.3 117.701 132.3 119.8C132.3 121.898 134.002 123.6 136.1 123.6Z",
    fill: "#C04F29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1 122.7C137.702 122.7 139 121.401 139 119.8C139 118.198 137.702 116.9 136.1 116.9C134.499 116.9 133.2 118.198 133.2 119.8C133.2 121.401 134.499 122.7 136.1 122.7Z",
    fill: "#CD7254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1 121H137.7C137.5 121 137.2 121.2 137.2 121.4L137.1 121.8C137 122.3 136.4 122.4 136.1 122L135.9 121.6C135.8 121.4 135.5 121.3 135.3 121.4L134.9 121.5C134.4 121.6 134 121.2 134.2 120.7L134.4 120.3C134.5 120.1 134.5 119.8 134.3 119.6L134 119.3C133.6 119 133.9 118.4 134.3 118.3H134.7C134.9 118.3 135.2 118.1 135.2 117.9L135.3 117.5C135.4 117 136 116.9 136.3 117.3L136.5 117.7C136.6 117.9 136.9 118 137.1 117.9L137.5 117.8C138 117.7 138.4 118.1 138.2 118.6L138 119C137.9 119.2 137.9 119.5 138.1 119.7L138.4 120C138.8 120.4 138.6 121 138.1 121Z",
    fill: "#D9957F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4 130L135.5 125.7C135.7 125.6 136 125.6 136.2 125.6L139.1 132L139.6 133.1C139.4 133.2 139.2 133.3 138.9 133.3L118.3 138.2C114.6 139.1 112.7 138.6 111.4 137.2C111.2 137 111 136.7 111 136.5L110.7 135.4C110.2 133.4 113.9 130.8 117.4 130Z",
    fill: "#E2A854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 133.1C136.6 133 135.2 131.6 134.8 130.1C134.4 128.6 134.1 126.9 136.2 125.7L139.5 133.1Z",
    fill: "#FDDEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3 133.7C127.1 133.9 127 134.1 127.1 134.1C127.2 134.1 127.3 134 127.4 133.9C127.5 133.8 127.6 133.7 127.8 133.5C128 133.3 128.3 133.1 128.5 132.8C129 132.3 129.6 131.7 129.6 131.7C129.6 131.7 130.1 131.2 130.8 130.4C131.1 130 131.5 129.7 131.8 129.3C132.1 129 132.4 128.6 132.5 128.5C132.8 128.2 133 127.9 133.2 127.7C133.4 127.5 133.5 127.3 133.4 127.3C133.3 127.3 133.2 127.4 133.1 127.5C133 127.6 132.9 127.7 132.7 127.9C132.5 128.1 132.2 128.3 132 128.6C131.5 129.1 130.9 129.7 130.9 129.7C130.9 129.7 130.4 130.2 129.7 130.9C129.4 131.3 129 131.6 128.7 132C128.4 132.3 128.1 132.7 128 132.8C127.7 133.2 127.5 133.4 127.3 133.7Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8 134.6C123.6 134.8 123.5 135.1 123.5 135C123.6 134.9 123.7 134.9 123.8 134.8C123.9 134.7 124 134.6 124.3 134.4C124.5 134.2 124.8 133.9 125.1 133.6C125.7 133 126.2 132.4 126.2 132.4C126.2 132.4 126.8 131.8 127.4 131C127.7 130.6 128.1 130.2 128.4 129.8C128.7 129.4 129 129.1 129.2 128.9C129.5 128.6 129.7 128.3 129.9 128C130.1 127.8 130.2 127.5 130.2 127.6C130.1 127.7 130 127.7 129.9 127.8C129.8 127.9 129.7 128 129.4 128.2C129.2 128.4 128.9 128.7 128.6 129C128 129.6 127.5 130.2 127.5 130.2C127.5 130.2 126.9 130.8 126.3 131.6C126 132 125.6 132.4 125.3 132.8C125 133.2 124.7 133.5 124.5 133.7C124.3 133.9 124.1 134.2 123.8 134.6C123.8 134.5 123.8 134.5 123.8 134.6Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3 135.4C120.1 135.6 120 135.9 120 135.8C120.1 135.7 120.2 135.7 120.3 135.6C120.4 135.5 120.5 135.4 120.8 135.2C121 135 121.3 134.7 121.6 134.4C122.2 133.8 122.7 133.2 122.7 133.2C122.7 133.2 123.2 132.6 123.9 131.9C124.2 131.5 124.6 131.1 124.9 130.7C125.2 130.3 125.5 130 125.6 129.8C125.9 129.5 126.1 129.2 126.3 128.9C126.5 128.7 126.6 128.4 126.6 128.5C126.5 128.6 126.4 128.6 126.3 128.7C126.2 128.8 126.1 128.9 125.8 129.1C125.6 129.3 125.3 129.6 125 129.9C124.5 130.5 123.9 131.1 123.9 131.1C123.9 131.1 123.4 131.7 122.7 132.4C122.4 132.8 122 133.2 121.7 133.6C121.4 134 121.1 134.3 121 134.5C120.8 134.8 120.6 135.1 120.3 135.4Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4 135.4C117.2 135.6 117.1 135.8 117.2 135.8C117.3 135.8 117.4 135.7 117.5 135.6C117.6 135.5 117.7 135.4 117.9 135.2C118.1 135 118.4 134.7 118.6 134.5C119.1 134 119.7 133.4 119.7 133.4C119.7 133.4 120.2 132.8 120.9 132.1C121.2 131.7 121.6 131.3 121.9 131C122.2 130.6 122.5 130.3 122.6 130.2C122.9 129.9 123.1 129.6 123.3 129.4C123.5 129.2 123.6 129 123.5 129C123.4 129 123.3 129.1 123.2 129.2C123.1 129.3 123 129.4 122.8 129.6C122.6 129.8 122.3 130.1 122.1 130.3C121.6 130.8 121 131.4 121 131.4C121 131.4 120.5 132 119.8 132.7C119.5 133.1 119.1 133.5 118.8 133.8C118.5 134.2 118.2 134.5 118.1 134.6C117.9 134.8 117.7 135.1 117.4 135.4C117.5 135.4 117.5 135.4 117.4 135.4Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.601 135.4C114.401 135.6 114.301 135.8 114.401 135.7C114.501 135.7 114.501 135.6 114.701 135.5C114.801 135.4 114.901 135.3 115.101 135.1C115.301 134.9 115.501 134.7 115.801 134.5C116.301 134 116.801 133.5 116.801 133.5C116.801 133.5 117.301 133 117.901 132.4C118.201 132.1 118.501 131.7 118.801 131.4C119.101 131.1 119.301 130.8 119.401 130.7C119.601 130.4 119.801 130.2 120.001 130C120.201 129.8 120.301 129.6 120.201 129.6C120.101 129.6 120.101 129.7 119.901 129.8C119.801 129.9 119.701 130 119.501 130.2C119.301 130.4 119.101 130.6 118.801 130.8C118.301 131.3 117.801 131.8 117.801 131.8C117.801 131.8 117.301 132.3 116.801 132.9C116.501 133.2 116.201 133.6 115.901 133.9C115.601 134.2 115.401 134.5 115.301 134.6C115.001 134.9 114.801 135.1 114.601 135.4Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1 135.6C112 135.7 111.9 135.9 112 135.9C112 135.9 112.1 135.8 112.2 135.8C112.2 135.8 112.3 135.7 112.4 135.5C112.5 135.4 112.7 135.2 112.8 135C113.1 134.7 113.4 134.3 113.4 134.3C113.4 134.3 113.7 133.9 114 133.5C114.2 133.3 114.4 133 114.5 132.8C114.7 132.6 114.8 132.4 114.9 132.3C115 132.1 115.1 131.9 115.3 131.8C115.4 131.7 115.5 131.5 115.4 131.5C115.4 131.5 115.3 131.6 115.2 131.6C115.2 131.6 115.1 131.7 115 131.9C114.9 132 114.7 132.2 114.6 132.4C114.3 132.7 114 133.1 114 133.1C114 133.1 113.7 133.5 113.4 133.9C113.2 134.1 113 134.4 112.9 134.6C112.7 134.8 112.6 135 112.5 135.1C112.4 135.2 112.3 135.4 112.1 135.6C112.2 135.6 112.2 135.6 112.1 135.6Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3 132.2C134.5 132.4 134.6 132.5 134.5 132.5C134.4 132.5 134.4 132.4 134.2 132.4C134.1 132.4 134 132.3 133.8 132.1C133.6 132 133.4 131.8 133.1 131.6C132.6 131.2 132.1 130.8 132.1 130.8C132.1 130.8 131.6 130.4 131 129.9C130.7 129.6 130.4 129.4 130.1 129.1C129.8 128.8 129.6 128.6 129.5 128.5C129.3 128.3 129.1 128.1 128.9 127.9C128.7 127.7 128.6 127.6 128.7 127.6C128.8 127.6 128.8 127.7 129 127.7C129.1 127.7 129.2 127.8 129.4 128C129.6 128.1 129.8 128.3 130.1 128.5C130.6 128.9 131.1 129.3 131.1 129.3C131.1 129.3 131.6 129.7 132.2 130.2C132.5 130.5 132.8 130.7 133.1 131C133.4 131.3 133.6 131.5 133.7 131.6C133.8 131.8 134 132 134.3 132.2C134.2 132.2 134.2 132.2 134.3 132.2Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2 133C131.4 133.2 131.5 133.3 131.4 133.3C131.3 133.3 131.3 133.2 131.1 133.2C131 133.2 130.9 133.1 130.7 132.9C130.5 132.8 130.3 132.6 130 132.4C129.5 132 129 131.6 129 131.6C129 131.6 128.5 131.2 127.9 130.7C127.6 130.4 127.3 130.2 127 129.9C126.7 129.6 126.5 129.4 126.4 129.3C126.2 129.1 126 128.9 125.8 128.7C125.6 128.5 125.5 128.4 125.6 128.4C125.7 128.4 125.7 128.5 125.9 128.5C126 128.5 126.1 128.6 126.3 128.8C126.5 128.9 126.7 129.1 127 129.3C127.5 129.7 128 130.1 128 130.1C128 130.1 128.5 130.5 129.1 131C129.4 131.3 129.7 131.5 130 131.8C130.3 132.1 130.5 132.3 130.6 132.4C130.8 132.6 131 132.8 131.2 133Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6 133.7C127.8 133.9 127.9 134 127.8 134C127.7 134 127.7 133.9 127.5 133.9C127.4 133.9 127.3 133.8 127.1 133.6C126.9 133.5 126.7 133.3 126.4 133.1C125.9 132.7 125.4 132.3 125.4 132.3C125.4 132.3 124.9 131.9 124.3 131.4C124 131.1 123.7 130.9 123.4 130.6C123.1 130.3 122.9 130.1 122.8 130C122.6 129.8 122.4 129.6 122.2 129.4C122 129.2 121.9 129.1 122 129.1C122.1 129.1 122.1 129.2 122.3 129.2C122.4 129.2 122.5 129.3 122.7 129.5C122.9 129.6 123.1 129.8 123.4 130C123.9 130.4 124.4 130.8 124.4 130.8C124.4 130.8 124.9 131.2 125.5 131.7C125.8 132 126.1 132.2 126.4 132.5C126.7 132.8 126.9 133 127 133.1C127.2 133.3 127.4 133.5 127.6 133.7Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 134.5C125 134.7 125.1 134.8 125 134.8C124.9 134.8 124.9 134.7 124.7 134.7C124.6 134.7 124.5 134.6 124.3 134.4C124.1 134.3 123.9 134.1 123.6 133.9C123.1 133.5 122.6 133.1 122.6 133.1C122.6 133.1 122.1 132.7 121.5 132.2C121.2 131.9 120.9 131.7 120.6 131.4C120.3 131.1 120.1 130.9 120 130.8C119.8 130.6 119.6 130.4 119.4 130.2C119.2 130 119.1 129.9 119.2 129.9C119.3 129.9 119.3 130 119.5 130C119.6 130 119.7 130.1 119.9 130.3C120.1 130.4 120.3 130.6 120.6 130.8C121.1 131.2 121.6 131.6 121.6 131.6C121.6 131.6 122.1 132 122.7 132.5C123 132.8 123.3 133 123.6 133.3C123.9 133.6 124.1 133.8 124.2 133.9C124.4 134.1 124.6 134.3 124.8 134.5Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 135.4C121.3 135.6 121.4 135.7 121.3 135.7C121.2 135.7 121.2 135.6 121 135.6C120.9 135.6 120.8 135.5 120.6 135.3C120.4 135.2 120.2 135 119.9 134.8C119.4 134.4 118.9 134 118.9 134C118.9 134 118.4 133.6 117.8 133.1C117.5 132.8 117.2 132.6 116.9 132.3C116.6 132 116.4 131.8 116.3 131.7C116.1 131.5 115.9 131.3 115.7 131.1C115.5 130.9 115.4 130.8 115.5 130.8C115.6 130.8 115.6 130.9 115.8 130.9C115.9 130.9 116 131 116.2 131.2C116.4 131.3 116.6 131.5 116.9 131.7C117.4 132.1 117.9 132.5 117.9 132.5C117.9 132.5 118.4 132.9 119 133.4C119.3 133.7 119.6 133.9 119.9 134.2C120.2 134.5 120.4 134.7 120.5 134.8C120.7 135 120.9 135.2 121.1 135.4Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3 136.6C118.5 136.8 118.6 136.9 118.5 136.9C118.4 136.9 118.4 136.8 118.2 136.8C118.1 136.8 118 136.7 117.8 136.5C117.6 136.4 117.4 136.2 117.1 136C116.6 135.6 116.1 135.2 116.1 135.2C116.1 135.2 115.6 134.8 115 134.3C114.7 134 114.4 133.8 114.1 133.5C113.8 133.2 113.6 133 113.5 132.9C113.3 132.7 113.1 132.5 112.9 132.3C112.7 132.1 112.6 132 112.7 132C112.8 132 112.8 132.1 113 132.1C113.1 132.1 113.2 132.2 113.4 132.4C113.6 132.5 113.8 132.7 114.1 132.9C114.6 133.3 115.1 133.7 115.1 133.7C115.1 133.7 115.6 134.1 116.2 134.6C116.5 134.9 116.8 135.1 117.1 135.4C117.4 135.7 117.6 135.9 117.7 136C117.9 136.2 118.1 136.4 118.3 136.6Z",
    fill: "#FF7945"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 211.5H154C152.5 211.5 151.3 210.3 151.3 208.8V203.7C151.3 202.2 152.5 201 154 201H446.4C447.9 201 449.1 202.2 449.1 203.7V208.8C449.1 210.3 447.9 211.5 446.4 211.5Z",
    className: "illustration_primary_default"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.5 88.0999H178.9C178.3 88.0999 177.8 87.5999 177.8 86.9999V86.6999C177.8 86.0999 178.3 85.5999 178.9 85.5999H181.5C182.1 85.5999 182.6 86.0999 182.6 86.6999V86.9999C182.7 87.5999 182.2 88.0999 181.5 88.0999Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.449 86.5209L170.7 107.243L171.334 107.541L181.082 86.8189L180.449 86.5209Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.008 86.5559L180.375 86.854L190.125 107.574L190.759 107.276L181.008 86.5559Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2 88.6999H181.5C180.5 88.6999 179.6 87.8999 179.6 86.7999C179.6 85.7999 180.4 84.8999 181.5 84.8999H182.2C183.2 84.8999 184.1 85.6999 184.1 86.7999C184.1 87.7999 183.3 88.6999 182.2 88.6999Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9 105.6H178.9H157.9V123.5V148.8H201.1V143.7V127.2V117.8V105.6H188.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6 105.6H160.4V148.8H203.6V105.6Z",
    className: "illustration_primary-light"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7 133.1C196.4 134.4 196.4 136.5 197.7 137.9L203.6 143.8V148.9H160.4V123.6C161.6 124.2 163.2 124 164.2 122.9L181.4 105.7H191.4L203.6 117.9V127.3L197.7 133.1Z",
    className: "illustration_primary-light"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.3 144.7C186.829 144.7 190.5 143.402 190.5 141.8C190.5 140.198 186.829 138.9 182.3 138.9C177.771 138.9 174.1 140.198 174.1 141.8C174.1 143.402 177.771 144.7 182.3 144.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.8 118.8C188.8 119.6 179.5 120.4 171.2 124.2C169.2 125.2 166.6 127.3 167.9 129.8C170 132.9 174.7 133.1 178.2 133.5C183.4 133.9 188.6 133.6 193.7 132.9C194 132.9 194.3 133.1 194.3 133.4C194.3 133.7 194.1 134 193.8 134C188.6 134.6 183.3 134.8 178.1 134.4C174.4 133.9 169.4 133.7 167.2 130.2C165.7 127.3 168.5 124.8 170.9 123.7C174.5 122 178.3 121.1 182.2 120.4C187.3 119.5 192.5 118.9 197.7 118.6C198 118.5 198 118.8 197.8 118.8Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6 141.3C182 141.3 181.4 141.3 180.8 141.2C178 140.8 175.8 139.5 175.1 137.9C174.7 137.1 174.8 136.3 175.2 135.6C175.3 135.5 175.5 135.4 175.6 135.5C175.7 135.6 175.8 135.8 175.7 135.9C175.4 136.4 175.3 137.1 175.6 137.7C176.2 139.1 178.3 140.2 180.8 140.6C183.3 141 185.6 140.5 186.7 139.3C187.2 138.8 187.3 138.2 187.1 137.6C187.1 137.4 187.2 137.3 187.3 137.2C187.5 137.2 187.6 137.3 187.7 137.4C187.9 138.2 187.7 139 187.1 139.7C186.3 140.8 184.6 141.3 182.6 141.3Z",
    fill: "#6F5BA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.1 123.2L187.5 138.2C187.4 138.8 187 139.4 186.3 139.9C185.9 140.2 185.4 140.4 184.9 140.5C183.8 140.8 182.4 140.9 180.9 140.7C177.2 140.1 175 138.1 175.3 136.4L175.7 120.7L192.1 123.2Z",
    fill: "#D8D0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 123.1L186.3 140C185.9 140.3 185.4 140.5 184.9 140.6L188.9 122.8L191 123.1Z",
    fill: "#D52629"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.6 140.1L177.9 138.4L178.9 137L178.2 135.4L179.2 134L178.5 132.4L179.5 131L178.8 129.4L179.8 128L179.1 126.4L180.1 125L179.4 123.4L180.5 121.8L180.9 122.1L180 123.4L180.7 125L179.7 126.4L180.4 128L179.4 129.4L180.1 131L179.1 132.4L179.8 134L178.8 135.4L179.5 137L178.5 138.4L179.3 140.2C179.3 140.2 179.2 140.2 178.9 140.1C178.8 140.2 178.6 140.1 178.6 140.1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.3 124.8C188.8 125.8 186.2 126.3 183.1 125.8C180 125.3 177.7 124.1 176.5 122.7C175.5 121.5 175.3 120.2 176 119.1C177.2 117.2 180.9 116.3 184.4 116.8C187.9 117.3 191.1 119.2 191.7 121.4C192.2 122.8 191.6 124 190.3 124.8Z",
    fill: "#D8D0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8 120.9C178.8 120.9 180.9 118.1 181.3 118.7C180.9 120 184.3 118 184.6 118.6C183.8 119.3 185.8 119.5 185.9 119.1C186 118.3 187.6 118.7 187.6 119.7C187.6 120.7 187.4 120.2 187.4 120.5C187.4 120.9 189.5 121.3 189.1 120.4C189.6 119.7 190.9 122 190.9 122.6C190.9 123.2 191.2 124.3 190.2 124.9C189.2 125.4 186.4 123.7 186.4 123.7L178.8 120.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.3 124.8C188.8 125.8 186.2 126.3 183.1 125.8C180 125.3 177.7 124.1 176.5 122.7C176.6 122.5 176.7 122.2 176.8 122C177.8 120.4 180.9 119.6 183.9 120.1C186.9 120.6 189.6 122.1 190.1 124C190.3 124.3 190.3 124.6 190.3 124.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3 126.8C184.6 126.8 183.8 126.7 183 126.6C179.4 126.1 176.5 124.4 175.5 122.3C175 121.3 175.1 120.2 175.7 119.2C176.9 117.2 180.6 116.2 184.5 116.8C188.3 117.4 191.6 119.4 192.2 121.7C192.5 122.8 192.2 123.8 191.5 124.7C190.2 126 188 126.8 185.3 126.8ZM182.4 117.4C179.7 117.4 177.3 118.2 176.4 119.6C176 120.3 175.9 121.1 176.3 121.9C177.1 123.7 179.8 125.2 183.2 125.7C186.5 126.2 189.6 125.6 190.9 124.1C191.5 123.4 191.7 122.6 191.5 121.8C191 119.9 188 118 184.5 117.5C183.7 117.5 183 117.4 182.4 117.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7 122.8C181.031 122.8 181.3 122.531 181.3 122.2C181.3 121.868 181.031 121.6 180.7 121.6C180.368 121.6 180.1 121.868 180.1 122.2C180.1 122.531 180.368 122.8 180.7 122.8Z",
    fill: "#5D1E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.3 122.9C189.631 122.9 189.9 122.631 189.9 122.3C189.9 121.969 189.631 121.7 189.3 121.7C188.968 121.7 188.7 121.969 188.7 122.3C188.7 122.631 188.968 122.9 189.3 122.9Z",
    fill: "#5D1E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2 124.2C182.531 124.2 182.8 123.931 182.8 123.6C182.8 123.269 182.531 123 182.2 123C181.868 123 181.6 123.269 181.6 123.6C181.6 123.931 181.868 124.2 182.2 124.2Z",
    fill: "#5D1E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 120.8C184.331 120.8 184.6 120.531 184.6 120.2C184.6 119.868 184.331 119.6 184 119.6C183.669 119.6 183.4 119.868 183.4 120.2C183.4 120.531 183.669 120.8 184 120.8Z",
    fill: "#5D1E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.7 111.1L185.1 122.7C185 122.9 185.2 123.2 185.5 123.4C185.8 123.6 186.2 123.5 186.3 123.3L191.9 111.7C192 111.5 191.8 111.2 191.5 111.1C191.1 110.9 190.8 110.9 190.7 111.1Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 122C185.7 122.4 186 122.8 186.4 123.1L186.7 122.5C186.3 122.1 186 121.7 185.9 121.2L185.5 122Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.299 120.2C186.499 120.6 186.799 121 187.199 121.3L187.499 120.7C187.099 120.3 186.799 119.9 186.699 119.4L186.299 120.2Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.2 118.4C187.4 118.8 187.7 119.2 188.1 119.5L188.4 118.9C188 118.5 187.7 118.1 187.6 117.6L187.2 118.4Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 116.7C188.2 117.1 188.5 117.5 188.9 117.8L189.2 117.2C188.8 116.8 188.5 116.4 188.4 115.9L188 116.7Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.899 114.9C189.099 115.3 189.399 115.7 189.799 116L190.099 115.4C189.699 115 189.399 114.6 189.299 114.1L188.899 114.9Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7 113.2C189.9 113.6 190.2 114 190.6 114.3L190.9 113.7C190.5 113.3 190.2 112.9 190.1 112.4L189.7 113.2Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.4 111.1C191.7 111.2 191.8 111.5 191.7 111.6C191.6 111.7 191.4 111.8 191.1 111.7C190.8 111.6 190.7 111.4 190.8 111.2C190.9 111 191.2 111 191.4 111.1Z",
    fill: "#D8D0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6 123.3C182.6 123.3 183.7 121.6 185.6 121.8C187.4 122 187.5 124.2 187.5 124.2L184.2 124.1L182.6 123.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6 128.4C168.4 135.4 188.5 132.8 193.7 132.1C195.5 131.8 196 134.6 194.2 134.9C188.5 135.3 167.2 136.5 167 128.4C166.9 127.9 167.6 127.9 167.6 128.4Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.2 118.4C190.2 118.4 192.4 115.1 193.1 116.5C193.9 117.8 190.2 118.4 190.2 118.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 118.7C182 118.7 182.8 116.3 183.5 117C184.2 117.7 182 118.7 182 118.7Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.4 200.9H170.5V184.1C170.5 181.7 172.4 181.2 174.8 181.2H176C178.4 181.2 180.3 181.7 180.3 184.1V200.9H180.4Z",
    className: "illustration_primary-lightest"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 200.9H180.6V179.8C180.6 176.8 183 176.2 186 176.2H187.5C190.5 176.2 192.9 176.8 192.9 179.8V200.9H193Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.4 134.9H346.3V122.7C346.3 121 348.3 120.6 350.7 120.6H352C354.4 120.6 356.4 121 356.4 122.7V134.9Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.1 134.9H407.1V119.6C407.1 117.4 409.7 117 412.8 117H414.4C417.5 117 420.1 117.5 420.1 119.6V134.9Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.3 134.9H421.4V125.4C421.4 124.1 423 123.8 424.9 123.8H425.9C427.8 123.8 429.4 124.1 429.4 125.4V134.9H429.3Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.6 134.9H357.8V118C357.8 115.6 359.7 115.1 362.1 115.1H363.3C365.7 115.1 367.6 115.6 367.6 118V134.9Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.8 134.9H378.3V123.4C378.3 121.8 379.4 121.4 380.7 121.4H381.4C382.7 121.4 383.8 121.7 383.8 123.4V134.9Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.5 134.9H369V121.9C369 120.1 370.5 119.7 372.3 119.7H373.2C375 119.7 376.5 120.1 376.5 121.9V134.9Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.4 134.9H397.9V123.4C397.9 121.8 399.4 121.4 401.2 121.4H402.1C403.9 121.4 405.4 121.7 405.4 123.4V134.9Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.6 134.9H385.4V126C385.4 124.8 387.4 124.5 389.9 124.5H391.2C393.7 124.5 395.7 124.8 395.7 126V134.9H395.6Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.3 83.7H399.3V68.4C399.3 66.2 396.7 65.8 393.6 65.8H392C388.9 65.8 386.3 66.3 386.3 68.4V83.7Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377 83.6999H384.9V74.1999C384.9 72.8999 383.3 72.5999 381.4 72.5999H380.4C378.5 72.5999 376.9 72.8999 376.9 74.1999V83.6999H377Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.5 83.6999H428V72.0999C428 70.4999 426.9 70.0999 425.6 70.0999H424.9C423.6 70.0999 422.5 70.3999 422.5 72.0999V83.6999Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.9 83.6999H408.4V72.0999C408.4 70.4999 406.9 70.0999 405.1 70.0999H404.2C402.4 70.0999 400.9 70.3999 400.9 72.0999V83.6999Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.7 83.7H420.9V74.8C420.9 73.6 418.9 73.3 416.4 73.3H415.1C412.6 73.3 410.6 73.6 410.6 74.8V83.7H410.7Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.2 83.6999H374V74.8999C374 73.6999 372.5 73.3999 370.6 73.3999H369.6C367.7 73.3999 366.2 73.6999 366.2 74.8999V83.6999Z",
    className: "illustration_primary"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.6 312.7H389.4C388.6 312.7 388 312.1 388 302.1V285.9C388 285.9 388.6 279.9 389.4 279.9H393.6C394.4 279.9 395 285.9 395 285.9V302.1C395 312.1 394.4 312.7 393.6 312.7Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 312.7H347.8C347 312.7 346.4 312.1 346.4 302.1V271.9C346.4 280.4 347 279.8 347.8 279.8H352C352.8 279.8 353.4 280.4 353.4 271.9V302.1C353.4 312.1 352.8 312.7 352 312.7Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.3 329.5H340.1C339.3 329.5 338.7 328.9 338.7 328.1V288.6C338.7 287.8 339.3 287.2 340.1 287.2H344.3C345.1 287.2 345.7 287.8 345.7 288.6V328C345.7 328.9 345.1 329.5 344.3 329.5Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.701 329.5H386.501C385.701 329.5 385.101 328.9 385.101 328.1V288.6C385.101 287.8 385.701 287.2 386.501 287.2H390.701C391.501 287.2 392.101 287.8 392.101 288.6V328C392.001 328.9 391.401 329.5 390.701 329.5Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.6 280.4V286.5C398.6 286.8 398.6 287.2 398.5 287.5C398.1 289.3 396.4 290.6 394.5 290.6H337.3C335 290.6 333.2 288.7 333.2 286.5V221.3C333.2 219 335.1 217.2 337.3 217.2H352.7C355 217.2 356.8 219.1 356.8 221.3V276.2H394.5C396.7 276.2 398.6 278.1 398.6 280.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.6 278.1V284.2C398.6 284.5 398.6 284.9 398.5 285.2H341.3C339 285.2 337.2 283.3 337.2 281.1V218.6C337.2 218.3 337.2 217.9 337.3 217.6H352.7C355 217.6 356.8 219.5 356.8 221.7V274H394.5C396.7 273.9 398.6 275.8 398.6 278.1Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5 321.3C442.049 321.3 450.6 319.196 450.6 316.6C450.6 314.004 442.049 311.9 431.5 311.9C420.952 311.9 412.4 314.004 412.4 316.6C412.4 319.196 420.952 321.3 431.5 321.3Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.5 262.3C467.779 262.3 498 258.942 498 254.8C498 250.658 467.779 247.3 430.5 247.3C393.221 247.3 363 250.658 363 254.8C363 258.942 393.221 262.3 430.5 262.3Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.5 261.8C467.779 261.8 498 258.442 498 254.3C498 250.158 467.779 246.8 430.5 246.8C393.221 246.8 363 250.158 363 254.3C363 258.442 393.221 261.8 430.5 261.8Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.8 252.4C384.8 250.9 392.2 249.9 399.8 249.9C407.4 249.9 414.8 250.9 416.8 252.4C419.4 254.4 412.1 256.4 399.8 256.4C387.5 256.4 380.2 254.3 382.8 252.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.8 252.1C384.8 250.6 392.2 249.6 399.8 249.6C407.4 249.6 414.8 250.6 416.8 252.1C419.4 254.1 412.1 256.1 399.8 256.1C387.5 256.2 380.2 254.1 382.8 252.1Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 252.1C390.2 251.1 395 250.5 399.8 250.5C404.6 250.5 409.3 251.1 410.6 252.1C412.2 253.3 407.6 254.7 399.8 254.7C392 254.7 387.3 253.3 389 252.1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.2 200.9H304.5V186.9C304.5 184.9 308.6 184.5 312.4 184.5H312.6C316.4 184.5 320.2 184.9 320.2 186.9V200.9Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5 197.2H319.7C319.3 197.2 318.9 196.9 318.9 196.4C318.9 195.9 319.2 195.6 319.7 195.6H323.4C323.5 195.5 323.8 194.9 323.8 193.1C323.8 191.3 323.5 190.7 323.3 190.5H319.4C319 190.5 318.6 190.2 318.6 189.7C318.6 189.2 318.9 188.9 319.4 188.9H323.5H323.6C324.1 189 325.3 189.5 325.3 193C325.3 196.9 324 197.2 323.5 197.2Z",
    className: "illustration_primary-lightest"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.9 200.9H335.2V186.9C335.2 184.9 339.3 184.5 343.1 184.5H343.3C347.1 184.5 350.9 184.9 350.9 186.9V200.9Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.2 197.2H350.4C350 197.2 349.6 196.9 349.6 196.4C349.6 195.9 349.9 195.6 350.4 195.6H354.1C354.2 195.5 354.5 194.9 354.5 193.1C354.5 191.3 354.2 190.7 354 190.5H350.1C349.7 190.5 349.3 190.2 349.3 189.7C349.3 189.2 349.6 188.9 350.1 188.9H354.2H354.3C354.8 189 356 189.5 356 193C356 196.9 354.7 197.2 354.2 197.2Z",
    className: "illustration_primary-lightest"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_359_45697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 53,
    width: 354,
    height: 347
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 53.2H73.3999V399.7H426.7V53.2Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_359_45697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.7 200.9H366V186.9C366 184.9 370.1 184.5 373.9 184.5H374.1C377.9 184.5 381.7 184.9 381.7 186.9V200.9Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.9 197.2H381.1C380.7 197.2 380.3 196.9 380.3 196.4C380.3 195.9 380.6 195.6 381.1 195.6H384.8C384.9 195.5 385.2 194.9 385.2 193.1C385.2 191.3 384.8 190.7 384.7 190.5H380.8C380.4 190.5 380 190.2 380 189.7C380 189.2 380.3 188.9 380.8 188.9H384.9C385.5 189 386.7 189.5 386.7 193C386.7 196.9 385.5 197.2 384.9 197.2Z",
    className: "illustration_primary-lightest"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafeteria);
export default __webpack_public_path__ + "static/media/Cafeteria.ca3168a6.svg";
export { ForwardRef as ReactComponent };